
import React from 'react';
import { Card } from 'antd'; // Use Ant Design Card for panel structure
import ChartRenderer from './ChartRenderer';
import SourceBarList from './SourceBarList';
import { MetricConfig } from './types';
import { dashboardConfig } from './dashboardConfig';

const DashboardPanelContent: React.FC<{ config: MetricConfig }> = ({ config }) => {
    if (config.type === 'chart') {
        return <ChartRenderer config={config} />;
    }
    if (config.type === 'custom') {
        return <SourceBarList config={config as any} />;
    }
    return <div>Unknown Component Type</div>;
};


const AnalyticsDashboard: React.FC = () => {
    return (
        <div className=" ">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
                {dashboardConfig.map((config) => (
                    <div key={config.id} className={config.span}>
                        <Card
                            title={config.title}
                            bordered={false}
                            size="small"
                            className="shadow-md rounded-lg" // Tailwind for styling
                            headStyle={{
                                borderBottom: '1px solid #f0f0f0',
                                fontWeight: '600'
                            }}
                            extra={<span className="text-gray-500 text-xs">{config.subtitle}</span>}
                        >
                            <DashboardPanelContent config={config} />
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AnalyticsDashboard;